<template>
  <v-app class="overflow-hidden">
    <slot />
    <confirm ref="confirm"></confirm>
  </v-app>
</template>
<script>
import confirm from '@components/confirm.vue'
import { initConfirm } from '@src/utils'
export default {
  components: { confirm },
  computed: {},
  data: () => ({}),
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
    initConfirm(this.$refs.confirm.open)
  },
  methods: {},
}
</script>
